// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-login {
    width: 100%;
    max-width: 400px;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    background-color: #fff;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2vh;
}

.logo-login {
    width: 45px;
    height: auto;
    cursor: pointer;
}

.button-social {
    width: 100%;
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #f0f0f0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    cursor: pointer;
}

.social-icon {
    width: 20px;
    height: auto;
}

.divider {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.divider-line {
    width: 100%;
    height: 0.5px;
    background-color: #f0f0f0;
}

.form-login {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1.8vh;

}

.form-group {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 0.5vh;
}

.input-login {
    width: 100%;
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #f0f0f0;
    font-size: 14px;
    font-family: "Inter", sans-serif;
}

.label-data{
    width: 100%;
    padding-inline: 10px;
    padding-block: 4px;
    border-bottom: 1px solid #dddddd;
    font-size: 13px;
    font-family: "Inter", sans-serif;
    color: #2e2e2ed8;
}

.input-login:focus {
    border-color: #FF6600;
}

.btn-login {
    width: 100%;
    padding: 10px;
    border-radius: 5px;
    background-color: #FF6600;
    color: #fff;
    font-size: 14px;
    font-family: "Inter", sans-serif;
    cursor: pointer;
}

.text-forgot {
    
    font-size: 12px;
    font-family: "Inter", sans-serif;
    color: black;
    text-decoration: underline;
    text-align: right;
    cursor: pointer;
    margin: 0;
    margin-left: auto;
}

@media screen and (max-width: 768px) {
    .card-login {
        width: 90%;
        margin-top: -20vh;
    }


    
}`, "",{"version":3,"sources":["webpack://./src/Components/style/signin.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;;AAEd;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,UAAU;AACd;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,gCAAgC;IAChC,eAAe;AACnB;;AAEA;;IAEI,eAAe;IACf,gCAAgC;IAChC,YAAY;IACZ,0BAA0B;IAC1B,iBAAiB;IACjB,eAAe;IACf,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI;QACI,UAAU;QACV,iBAAiB;IACrB;;;;AAIJ","sourcesContent":[".card-login {\n    width: 100%;\n    max-width: 400px;\n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    background-color: #fff;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 2vh;\n}\n\n.logo-login {\n    width: 45px;\n    height: auto;\n    cursor: pointer;\n}\n\n.button-social {\n    width: 100%;\n    padding: 10px;\n    border-radius: 5px;\n    border: 1px solid #f0f0f0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    cursor: pointer;\n}\n\n.social-icon {\n    width: 20px;\n    height: auto;\n}\n\n.divider {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n}\n\n.divider-line {\n    width: 100%;\n    height: 0.5px;\n    background-color: #f0f0f0;\n}\n\n.form-login {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 1.8vh;\n\n}\n\n.form-group {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    gap: 0.5vh;\n}\n\n.input-login {\n    width: 100%;\n    padding: 10px;\n    border-radius: 5px;\n    border: 1px solid #f0f0f0;\n    font-size: 14px;\n    font-family: \"Inter\", sans-serif;\n}\n\n.label-data{\n    width: 100%;\n    padding-inline: 10px;\n    padding-block: 4px;\n    border-bottom: 1px solid #dddddd;\n    font-size: 13px;\n    font-family: \"Inter\", sans-serif;\n    color: #2e2e2ed8;\n}\n\n.input-login:focus {\n    border-color: #FF6600;\n}\n\n.btn-login {\n    width: 100%;\n    padding: 10px;\n    border-radius: 5px;\n    background-color: #FF6600;\n    color: #fff;\n    font-size: 14px;\n    font-family: \"Inter\", sans-serif;\n    cursor: pointer;\n}\n\n.text-forgot {\n    \n    font-size: 12px;\n    font-family: \"Inter\", sans-serif;\n    color: black;\n    text-decoration: underline;\n    text-align: right;\n    cursor: pointer;\n    margin: 0;\n    margin-left: auto;\n}\n\n@media screen and (max-width: 768px) {\n    .card-login {\n        width: 90%;\n        margin-top: -20vh;\n    }\n\n\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
